export interface DashboardStatisticSecondary {
  percentage    : string;
  prefix        : string;
  profit        : string;
  profitUpIsGood: boolean;
  value         : number;
};

export interface DashboardStatistic {
  decimalPlaces : number | undefined;
  icon          : string | undefined;
  iconColour?   : string;
  link          : string | undefined;
  linkText      : string | undefined;
  loading       : boolean;
  percentage    : string | undefined;
  prefix?       : string;
  profit        : string | undefined;
  profitUpIsGood: boolean | undefined;
  secondaries?  : DashboardStatisticSecondary[];
  showProfit    : boolean;
  showSpinner   : boolean;
  subTitle?     : string;
  title         : string | undefined;
  unit?         : string;
  value         : string | number | undefined;
  widgetName?   : string;
};

export function DashboardStatistic_EmptyObject(): DashboardStatistic {
  return {
    decimalPlaces : undefined,
    icon          : undefined,
    link          : undefined,
    linkText      : undefined,
    loading       : false,
    percentage    : undefined,
    profit        : undefined,
    profitUpIsGood: undefined,
    showProfit    : false,
    showSpinner   : false,
    subTitle      : undefined,
    title         : undefined,
    value         : undefined,
    widgetName    : undefined,
  }
};
